import React from 'react';
import { Link } from 'react-router-dom';

import { LinkButton } from '@/components/Button';

import { ArrowLeft, Compass, Search } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      
      
      
      <main className="flex-grow flex items-start justify-center text-center pt-24 pb-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-lg mx-auto">
            <Compass className="mx-auto h-24 w-24 text-gray-300" strokeWidth={1} />
            <h2 className="mt-6 text-2xl font-bold text-gray-800">It seems you've taken a wrong turn.</h2>
            <p className="mt-2 text-gray-500">Let's get you back on track. You can return to the homepage or try one of these popular pages:</p>

            <div className="mt-8 flex justify-center gap-4">
              <LinkButton 
                to="/" 
                variant="solid"
                className="px-6 py-3 rounded-lg font-semibold shadow-sm"
              >
                <ArrowLeft className="h-5 w-5 mr-2" />
                Go to Homepage
              </LinkButton>
              <LinkButton 
                to="/investments" 
                variant="outline"
                colorScheme="dark"
                className="px-6 py-3 rounded-lg font-semibold shadow-sm"
              >
                <Search className="h-5 w-5 mr-2" />
                View Investments
              </LinkButton>
            </div>

            <div className="mt-12 text-sm text-gray-600">
              <p>If you believe this is an error, please <Link to="/help-center" className="font-medium underline hover:text-gray-600">contact our support team</Link>.</p>
              <p className="mt-1">Error Code: 404</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
